import { Box } from '@mui/material'
import HomeDatasetsContent from './HomeDatasetsContent'
import HomeDatasetsHeader from './HomeDatasetsHeader'
import { useAppSelector } from 'app/state'
import { RequestStatus } from 'features/common'
import Loader from 'features/common/ui/utils/Loader'

export function HomeDatasets({
  titleId,
  withExploreButton = true,
  withImportButton = true,
  maxDatasets
}: {
  titleId?: string
  withExploreButton?: boolean
  withImportButton?: boolean
  maxDatasets?: number
}) {
  const recentDatasets = useAppSelector((state) => state.connections.recentResources)
  const recentResourcesStatus = useAppSelector((state) => state.connections.recentResourcesStatus)

  if (recentDatasets.length === 0) return null

  return (
    <Box mb={8}>
      <HomeDatasetsHeader titleId={titleId} withExploreButton={withExploreButton} />
      {recentResourcesStatus === RequestStatus.Pending ? (
        <Loader />
      ) : (
        <HomeDatasetsContent datasets={recentDatasets} withImportButton={withImportButton} maxDatasets={maxDatasets} />
      )}
    </Box>
  )
}

export default HomeDatasets
